/*
 * UNIVERSIDAD AUTONOMA DE AGUASCALIENTES
 * DIRECCION GENERAL DE PLANEACION Y DESARROLLO
 * DEPARTAMENTO DE SISTEMAS (OPTIMIZACION DE PROYECTOS ADMINISTRATIVOS - OPA)
 *
 * PROYECTO:  COMPRAS
 * PROPOSITO: Menu para el flujo de productos y servicios.
 *
 * AUTOR:     FZALDIVAR
 * FECHA:     21/Oct/2019
 *
*/
import { Component, OnInit } from '@angular/core';
import { ApiParametrosService } from 'src/app/services/api-parametros.service';
import { IdProcedimiento } from 'src/app/models/IdProcedimiento';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { Globals } from 'src/app/globals';

@Component({
  selector: 'app-menu-producto',
  templateUrl: './menu-producto.component.html',
  styleUrls: ['./menu-producto.component.css']
})
export class MenuProductoComponent implements OnInit {

  public idProcedimiento: IdProcedimiento;
  public estatusProc: string;

  /*Opciones Menu*/
  public info: boolean = true;
  public subir_cotizacion: boolean = false;
  public orden_compra: boolean = false;

  constructor(private apiParams: ApiParametrosService, private router: Router, public globals: Globals) {   }

  ngOnInit() {
    this.idProcedimiento = this.apiParams.getIdProcedimiento();

    if (isNullOrUndefined(this.idProcedimiento)) {
      this.router.navigateByUrl('/procs');
      return;
    }
  }

  ActualizaMenu(event):void{
    this.estatusProc = event.estatusProveedorProceso;
  }

  ActualizaView(opcion: string){
    /*Refresca los componentes que se deben mostrar al usuario*/
    if (opcion === 'info'){
      this.info = true;
      this.subir_cotizacion = false;
      this.orden_compra = false;
    }

    if (opcion === 'orden_compra'){
      this.info = false;
      this.subir_cotizacion = false;
      this.orden_compra = true;
    }

    if (opcion === 'subir_cotizacion'){
      this.info = false;
      this.subir_cotizacion = true;
      this.orden_compra = false;
    }

  }
}
